module.exports = __webpack_public_path__ + "static/media/ic_ride_flex_logo_header.0d0cb0dc.svg";